import React, { type FunctionComponent, useMemo } from 'react'
import { FormattedDate, FormattedTime } from 'react-intl'
import moment from 'moment'
import { DashTableTextCell } from 'legacy/dash-blocks/dash-table-text-cell/DashTableTextCell'

interface Props {
  format: 'date' | 'time'
  createdAt: string
}

export const OrdersListTableCreatedAtCell: FunctionComponent<Props> = ({ format, createdAt }) => {
  const time = moment(createdAt).toDate()

  const renderedContent = useMemo(() => {
    if (format === 'date') {
      return <FormattedDate value={time} />
    }

    return <FormattedTime value={time} timeZoneName="short" />
  }, [format, time])

  return <DashTableTextCell>{renderedContent}</DashTableTextCell>
}
